export default __webpack_public_path__ + "static/droneSound-4b54c8d157d1443b2b89d71eda2248ae.png";